import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { Channel } from '~core/models/channel.models';
import { ChannelCreationFormComponent } from '../../components/channel-creation-form/channel-creation-form.component';
import { SharedModule } from '~app/app/~shared/modules/shared.module';

@Component({
  selector: 'channel-creation-dialog',
  standalone: true,
  imports: [SharedModule, ChannelCreationFormComponent],
  templateUrl: './channel-creation-dialog.component.html',
  styleUrl: './channel-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChannelCreationDialogComponent extends BaseComponent {
  channel = input<Channel | null>(null);
}
